import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getProfile ,registerWaitlist } from '../api/profileThunk';
import {UserProfile} from '../../utils/interface';

interface ProfileState {
  profile: UserProfile | null; 
  loading: boolean;
  error: string | null;
  toggle:boolean;
  needToFetched:boolean;

  waitlistLoading:boolean;
}

const initialState: ProfileState = {
  profile: null,
  loading: false,
  error: null,
  needToFetched:false,
  toggle:false,

  waitlistLoading:false,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setNeedtoFetched(state,action:PayloadAction<boolean>) {
      state.needToFetched = action.payload;
    },
    setToggle(state, action: PayloadAction<boolean>) {
      state.toggle = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfile.fulfilled, (state, action: PayloadAction<UserProfile>) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(getProfile.rejected, (state, action: PayloadAction<unknown>) => {
        state.loading = false;
        state.error = typeof action.payload === 'string' ? action.payload : 'An error occurred';
      })

      .addCase(registerWaitlist.pending, (state) => {
        state.waitlistLoading = true;
      })
      .addCase(registerWaitlist.fulfilled, (state, action: PayloadAction<any>) => {
        state.waitlistLoading = false;
      })
      .addCase(registerWaitlist.rejected, (state, action: PayloadAction<unknown>) => {
        state.waitlistLoading = false;
        state.error = typeof action.payload === 'string' ? action.payload : 'An error occurred';
      })
  },
});

  export const {
    setNeedtoFetched,
    setToggle
  } = profileSlice.actions;
export default profileSlice.reducer;
